import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import * as Sentry from '@sentry/react'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import localStore from 'store'
import throttle from 'lodash/throttle'

import apiRTKQ from './apiRTKQ'
import { initialState as initialPurchasingState } from './modules/buyer/modules/purchasing/slice'
import { initialState as initialSuppliersState } from './modules/buyer/modules/suppliers/slice'
import createRootReducer from './reducers'

export const history = createBrowserHistory()
const sentryReduxEnhancer = Sentry.createReduxEnhancer()

const createStore = () => {
  const store = configureStore({
    reducer: createRootReducer(history),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(
        routerMiddleware(history),
        apiRTKQ.middleware
      ),
    devTools: process.env.NODE_ENV !== 'production',
    enhancers: [sentryReduxEnhancer],
    preloadedState: {
      buyer: {
        purchasing: {
          ...initialPurchasingState,
          ...localStore.get('purchasing', {}),
        },
        suppliers: {
          ...initialSuppliersState,
          ...localStore.get('suppliers', {}),
        },
      },
    },
  })

  store.subscribe(
    throttle(() => {
      const { purchasingEnvironment } = store.getState().buyer.purchasing
      const { nearPostcode, nearEnvironment } = store.getState().buyer.suppliers
      localStore.set('purchasing', { purchasingEnvironment })
      localStore.set('suppliers', { nearPostcode, nearEnvironment })
    }, 1000)
  )

  // for RTK Query
  setupListeners(store.dispatch)

  return store
}

export default createStore
